import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../Actions/axios.config';

export const adminKeys = {
    all: ['admin'],
    feedbacks: () => [...adminKeys.all, 'feedbacks'],
    team: () => [...adminKeys.all, 'team'],
};

export const useFeedbacks = () => {
    return useQuery({
        queryKey: adminKeys.feedbacks(),
        queryFn: async () => {
            const { data } = await axios.get('/admin/feedback');
            return data.feedbacks || [];
        },
    });
};

export const useTeam = () => {
    return useQuery({
        queryKey: adminKeys.team(),
        queryFn: async () => {
            const { data } = await axios.get('/admin/team');
            if (data.success) {
                const colors = [
                    'bg-indigo-600',
                    'bg-rose-600',
                    'bg-amber-600',
                    'bg-emerald-600',
                    'bg-blue-600',
                ];
                return data.team.map((member, index) => ({
                    ...member,
                    id: member._id,
                    color: colors[index % colors.length],
                }));
            }
            return [];
        },
    });
};

export const useUpdateFeedback = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, updatePayload }) => axios.patch(`/admin/feedback/${id}`, updatePayload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: adminKeys.feedbacks() });
        },
    });
};
